import styles from './InvestigationAssetPanel.module.scss';
import { useTranslation } from 'react-i18next';
import { VdsButton } from '@volt/volt-extended-components-react';
import { DrawerPanel } from '@dmc/ui';
import { useAssetGroupChips } from '@customer/hooks/assets/useAssetGroupChips';
import AssetIdentifier from '@customer/components/asset-data/asset-identifier/AssetIdentifier';
import Tabs from '@cas/components/tabs/tabs/Tabs';
import useInvestigationAssetPanel from './useInvestigationAssetPanel';
import { CompletenessNotifications } from './completeness-notifications/CompletenessNotifications';

export function InvestigationAssetPanel() {
  const { t } = useTranslation();

  const { asset, tabsProps, activeView, btnProps } = useInvestigationAssetPanel();
  const vehicleGroupChips = useAssetGroupChips({ assetGroups: asset.groups });

  return (
    <DrawerPanel
      header={
        <div className={styles.header}>
          <AssetIdentifier
            name={asset.name}
            mismatch={asset.mismatch}
            deviceType={asset.hw ?? '0'}
          />
          <div className={styles.header__asset_type}>{vehicleGroupChips}</div>
          {asset.cmp && <CompletenessNotifications status={asset.cmp} />}
        </div>
      }
      tabs={asset && <Tabs {...tabsProps} hasBorder />}
      footer={
        asset &&
        btnProps && (
          <VdsButton {...btnProps} variant="primary" size="medium" isFullWidth>
            {t('AssetInteractions')}
          </VdsButton>
        )
      }
    >
      {asset && activeView}
    </DrawerPanel>
  );
}

export default InvestigationAssetPanel;
